<div class="main" *ngIf="purchaseOrder || purchaseOrderWV">
    <div class="content" *ngIf="pageType == PageType.WestVirginia">
        <div class="title">
            <div>
                Admin Edit<br />#{{purchaseOrderWV.poNumber}}
            </div>
            <div>
                Page: WestVirginia
            </div>
        </div>
        <div class="vendor">
            <p-dropdown
                    optionLabel="name"
                    appendTo="body" 
                    placeholder="Change Vendor" 
                    [options]="vendors"
                    [loading]="vendorListLoading"
                    [(ngModel)]="selectedVendor" 
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="38"
                    [virtualScrollOptions]="vendorsScrollerOptions"
                    [panelStyleClass]="vendorsLoaded ? 'loaded' : ''"
                    [filter]="true" 
                    (onChange)="changeVendor($event)"
                    >
                <ng-template pTemplate="selectedItem">
                    <span>{{selectedVendor.name}}</span>
                </ng-template>

                <ng-template pTemplate="filter" let-options="options">
                    <div class="vendors-filter-content">
                        <div class="p-inputgroup" (click)="$event.stopPropagation()" style="border: 1px solid rgba(0,0,0,.5); border-radius: 8px;">
                            <input 
                            class="no-focus-input"
                            style="border: none; background-color: rgba(0,0,0,0);"
                            type="text"
                            placeholder="Filter" 
                            [(ngModel)]="vendorsFilterValue"
                            (keyup.enter)="onFilterVendors($event)" />
                            <span><i style="padding: 0 5px; padding-top: 3px; cursor: pointer" class="pi pi-times" (click)="onClearVendorsFilter()"></i></span>
                        </div>
                        <div>
                            <p-button label="Apply filter" size="small" (click)="onFilterVendors($event)"/>
                        </div>
                    </div>
                </ng-template>
            </p-dropdown>
            <span *ngIf="!vendorhasCompleteData" style="color: red; font-size: .9rem; margin-left: 6px;">Selected Vendor has incomplete data</span>
        </div>
        <div class="row">
            <div class="input-field" style="width: 100%">
                <input type="text" pInputText [(ngModel)]="purchaseOrderWV.sellerFullName">
                <span>Full Name of Seller</span>
            </div>
        </div>
        <div class="box">
            <div class="title">Seller's Home Address:</div>
            <div class="row">
                <div class="input-field" style="width: 100%">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.homeAddress.address">
                    <span>Home Address</span>
                </div>
            </div>
            <div class="row">
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.homeAddress.country">
                    <span>Country</span>
                </div>
                <div class="input-field" style="width: 200px">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.homeAddress.zip">
                    <span>Zip</span>
                </div>
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.homeAddress.phoneNumber">
                    <span>Home Phone Number</span>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="title">Seller's Business Address:</div>
            <div class="row">
                <div class="input-field" style="width: 100%">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.businessAddress.address">
                    <span>Business Address</span>
                </div>
            </div>
            <div class="row">
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.businessAddress.country">
                    <span>Country</span>
                </div>
                <div class="input-field" style="width: 200px">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.businessAddress.zip">
                    <span>Zip</span>
                </div>
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.businessAddress.phoneNumber">
                    <span>Business Phone Number</span>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="title">Description of Motor Vehicle used for Transport:</div>
                            <div class="dropdown">
                    <p-dropdown [options]="purchaseOrderWV?.contacts ?? []" optionLabel="name" optionValue="id" placeholder="Select Contact" [(ngModel)]="selectedContactId" appendTo="body" (onChange)="contactChange()"></p-dropdown>
                </div>
            <div class="row">
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.vehicleMake">
                    <span>Vehicle Make</span>
                </div>
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.vehicleModel">
                    <span>Vehicle Model</span>
                </div>
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.vehicleColor">
                    <span>Vehicle Color</span>
                </div>
            </div>
            <div class="row">
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.vehicleNumber">
                    <span>Vehicle Number</span>
                </div>
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="purchaseOrderWV.vehicleState">
                    <span>Vehicle State</span>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="title">Description of the kind of Scrap Metal:</div>
            <div class="row" *ngFor="let sm of purchaseOrderWV.kindOfScrapMaterials">
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="sm.purchased">
                    <span>Purchased</span>
                </div>
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="sm.character">
                    <span>Character</span>
                </div>
                <div class="input-field" style="flex: 1">
                    <input type="text" pInputText [(ngModel)]="sm.weight">
                    <span>Weight</span>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="title">Was the Scrap Material:</div>
            <div class="row payment-type">
                <div class="types">
                    <p-checkbox [(ngModel)]="purchaseOrderWV.scrapMaterialPurchased" label="Purchased" [binary]="true"></p-checkbox>
                    <p-checkbox [(ngModel)]="purchaseOrderWV.scrapMaterialCollateral" label="Taken as Collateral" [binary]="true"></p-checkbox>
                    <p-checkbox [(ngModel)]="purchaseOrderWV.scrapMaterialConsignment" label="Taken on Consignment" [binary]="true"></p-checkbox>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="title">Payment Type:</div>
            <div class="row payment-type">
                <div style="display: flex; flex-direction: column; gap: -2px; font-size: .85rem">
                    <table>
                        <tr>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Purchase Price</th>
                            <th>Sum</th>
                            <th>Adjustment</th>
                            <th>Total</th>
                        </tr>
                        <tr>
                            <td>Converters</td>
                            <td>{{purchaseOrderWV?.converters?.quantity ?? 0}}</td>
                            <td>{{purchaseOrderWV?.converters?.purchasePrice ?? 0 | currency:poManager.current.currency:true}}</td>
                            <td rowspan="2">{{(purchaseOrderWV?.converters?.purchasePrice ?? 0) + (purchaseOrderWV?.nonFerrous?.purchasePrice ?? 0) | currency:poManager.current.currency:true}}</td>
                            <td>{{purchaseOrderWV?.catsAdjustment ?? 0| currency:poManager.current.currency:true}}</td>
                            <td rowspan="2">{{purchaseOrderWV?.total | currency:poManager.current.currency:true}}</td>
                        </tr>
                        <tr>
                            <td>Non-Ferrous</td>
                            <td>{{purchaseOrderWV?.nonFerrous?.quantity ?? 0}}</td>
                            <td>{{purchaseOrderWV?.nonFerrous?.purchasePrice ?? 0 | currency:poManager.current.currency:true}}</td>
                            <td>{{purchaseOrderWV?.nonFerrousAdjustment ?? 0| currency:poManager.current.currency:true}}</td>
                        </tr>
                    </table>
                </div>
                <div class="types">
                    <div class="box" *ngFor="let pt of purchaseOrderWV?.paymentTypes ?? [{type: 1, total: null},{type: 2, total: null},{type:4, total: null}]">
                        <p-checkbox [(ngModel)]="selectedPaymentTypes" [value]="pt.type" [label]="PaymentType[pt.type]"></p-checkbox>
                        <p-floatLabel *ngIf="selectedPaymentTypes.includes(pt.type)">
                            <p-inputNumber [(ngModel)]="pt.total" inputId="currency-us" mode="currency"
                                [currency]="purchaseOrderWV?.currency" locale="en-US" />
                            <label for="number-input">{{PaymentType[pt.type]}} total</label>
                        </p-floatLabel>
                        <p-floatLabel *ngIf="pt.type == 2 && selectedPaymentTypes.includes(pt.type)">
                            <input type="checkNumber" pInputText [(ngModel)]="pt.checkNumber"/>
                            <label for="checkNumber">{{PaymentType[pt.type]}} number (optional)</label>
                        </p-floatLabel>
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons">
            <p-button icon="pi pi-times" label="Cancel" severity="secondary" (click)="onCancel()"></p-button>
            <p-button icon="pi pi-save" label="Save" (click)="onSave()"></p-button>
        </div>
    </div>
    <div class="content" *ngIf="pageType != PageType.WestVirginia">
        <div class="title">
            <div>
                Admin Edit<br />#{{purchaseOrder.poNumber}}
            </div>
            <div>
                Page: {{PageType[pageType]}}
            </div>
        </div>
        <div class="vendor">
            <p-dropdown
                    optionLabel="name"
                    appendTo="body" 
                    placeholder="Change Vendor" 
                    [options]="vendors"
                    [loading]="vendorListLoading"
                    [(ngModel)]="selectedVendor" 
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="38"
                    [virtualScrollOptions]="vendorsScrollerOptions"
                    [panelStyleClass]="vendorsLoaded ? 'loaded' : ''"
                    [filter]="true" 
                    (onChange)="changeVendor($event)"
                    >
                <ng-template pTemplate="selectedItem">
                    <span>{{selectedVendor.name}}</span>
                </ng-template>

                <ng-template pTemplate="filter" let-options="options">
                    <div class="vendors-filter-content">
                        <div class="p-inputgroup" (click)="$event.stopPropagation()" style="border: 1px solid rgba(0,0,0,.5); border-radius: 8px;">
                            <input 
                            class="no-focus-input"
                            style="border: none; background-color: rgba(0,0,0,0);"
                            type="text"
                            placeholder="Filter" 
                            [(ngModel)]="vendorsFilterValue"
                            (keyup.enter)="onFilterVendors($event)" />
                            <span><i style="padding: 0 5px; padding-top: 3px; cursor: pointer" class="pi pi-times" (click)="onClearVendorsFilter()"></i></span>
                        </div>
                        <div>
                            <p-button label="Apply filter" size="small" (click)="onFilterVendors($event)"/>
                        </div>
                    </div>
                </ng-template>
            </p-dropdown>
            <span *ngIf="!vendorhasCompleteData" style="color: red; font-size: .9rem; margin-left: 6px;">Selected Vendor has incomplete data</span>
        </div>
        <div class="amounts">
            <table>
                <tr>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Purchase Price</th>
                    <th>Sum</th>
                    <th>Adjustment</th>
                    <th>Total</th>
                </tr>
                <tr>
                    <td>Converters</td>
                    <td>{{purchaseOrder?.converters?.quantity ?? 0}}</td>
                    <td>{{purchaseOrder?.converters?.purchasePrice ?? 0 | currency:poManager.current.currency:true}}</td>
                    <td rowspan="2">{{(purchaseOrder?.converters?.purchasePrice ?? 0) + (purchaseOrder?.nonFerrous?.purchasePrice ?? 0) | currency:poManager.current.currency:true}}</td>
                    <td>{{purchaseOrder?.catsAdjustment ?? 0| currency:poManager.current.currency:true}}</td>
                    <td rowspan="2">{{purchaseOrder?.total | currency:poManager.current.currency:true}}</td>
                </tr>
                <tr>
                    <td>Non-Ferrous</td>
                    <td>{{purchaseOrder?.nonFerrous?.quantity ?? 0}}</td>
                    <td>{{purchaseOrder?.nonFerrous?.purchasePrice ?? 0 | currency:poManager.current.currency:true}}</td>
                    <td>{{purchaseOrder?.nonFerrousAdjustment ?? 0| currency:poManager.current.currency:true}}</td>
                </tr>
            </table>
        </div>
        <div class="payment-type">
            <div class="title">
                Payment type
            </div>
            <div class="types{{deviceManager.isMobile ? '-mobile' : ''}}">
                <div class="box" *ngFor="let pt of purchaseOrder?.paymentTypes ?? []">
                    <p-checkbox [(ngModel)]="selectedPaymentTypes" [value]="pt.type" [label]="PaymentType[pt.type]"></p-checkbox>
                    <p-floatLabel *ngIf="selectedPaymentTypes.includes(pt.type)">
                        <p-inputNumber [(ngModel)]="pt.total" inputId="currency-us" mode="currency"
                            [currency]="purchaseOrder?.currency" locale="en-US" />
                        <label for="number-input">{{PaymentType[pt.type]}} total</label>
                    </p-floatLabel>
                    <p-floatLabel *ngIf="pt.type == 2 && selectedPaymentTypes.includes(pt.type)">
                        <input type="checkNumber" pInputText [(ngModel)]="pt.checkNumber"/>
                        <label for="checkNumber">{{PaymentType[pt.type]}} number (optional)</label>
                    </p-floatLabel>
                </div>
            </div>
        </div>
        <div class="seller-info" *ngIf="!(pageType == PageType.California && selectedPaymentTypes.includes(PaymentType.Cash))">
            <div class="title">Seller information</div>
            <div class="fields">
                <div class="dropdown">
                    <p-dropdown [options]="purchaseOrder?.contacts ?? []" optionLabel="name" optionValue="id" placeholder="Select Contact" [(ngModel)]="selectedContactId" appendTo="body" (onChange)="contactChange()"></p-dropdown>
                </div>
                <div class="infos">
                    <div class="id-dl">ID or DL #: {{selectedContact?.license}}</div>
                    <div class="state">State: {{selectedContact?.state}}</div>
                </div>
            </div>
            <div style="color: red; font-size: .8rem; margin-top: -2px;" *ngIf="selectedContact?.valid == false">Contact data is incomplete</div>
        </div>
        <div class="vehicle-info">
            <div class="title">Vehicle info</div>
            <div class="fields">
                <div class="input-field">
                    <input type="text" pInputText [(ngModel)]="purchaseOrder.vehicleMake">
                    <span>Make {{isOptional('make') ? '(optional)' : ''}}</span>
                </div>
                <div class="input-field">
                    <input type="text" pInputText [(ngModel)]="purchaseOrder.vehicleModel">
                    <span>Model {{isOptional('model') ? '(optional)' : ''}}</span>
                </div>
                <div class="input-field">
                    <input type="text" pInputText [(ngModel)]="purchaseOrder.vehicleColor">
                    <span>Color {{isOptional('color') ? '(optional)' : ''}}</span>
                </div>
                <div class="input-field" *ngIf="!(pageType == PageType.California && selectedPaymentTypes.includes(PaymentType.Cash))">
                    <input type="text" pInputText [(ngModel)]="purchaseOrder.vehicleNumber">
                    <span>Registration # {{isOptional('license') ? '(optional)' : ''}}</span>
                </div>
                <div class="input-field" *ngIf="!(pageType == PageType.California && selectedPaymentTypes.includes(PaymentType.Cash))">
                    <input type="text" pInputText [(ngModel)]="purchaseOrder.vehicleState">
                    <span>State {{isOptional('state') ? '(optional)' : ''}}</span>
                </div>
            </div>
        </div>

        <div class="seller-info-california" *ngIf="pageType == PageType.California && selectedPaymentTypes.includes(PaymentType.Cash)">
            <div class="title">Seller information</div>
            <div class="fields">
                <div class="dropdown">
                    <p-dropdown [options]="purchaseOrder?.contacts ?? []" optionLabel="name" optionValue="id" placeholder="Select Contact" [(ngModel)]="selectedContactId" appendTo="body"></p-dropdown>
                </div>
                <div class="infos">
                    <div class="row{{deviceManager.isMobile ? '-mobile' : ''}}">
                        <div class="input-field" style="flex: 1" *ngIf="selectedContact">
                            <input type="text" pInputText [disabled]="true" [(ngModel)]="selectedContact.firstName">
                            <span>First Name</span>
                        </div>
                        <div class="input-field" style="flex: 1" *ngIf="selectedContact">
                            <input type="text" pInputText [disabled]="true" [(ngModel)]="selectedContact.lastName">
                            <span>Last Name</span>
                        </div>
                        <div class="input-field" style="flex: 1">
                            <input type="text" pInputText [(ngModel)]="purchaseOrder.middleInitial">
                            <span>Middle Initial</span>
                        </div>
                    </div>
                    <div class="row{{deviceManager.isMobile ? '-mobile' : ''}}" *ngIf="selectedContact">
                        <div class="input-field" style="flex: 1">
                            <input type="text" pInputText [disabled]="true" [(ngModel)]="selectedContact.license">
                            <span>Driver's License Number</span>
                        </div>
                        <div class="input-field" style="flex: 1">
                            <input type="text" pInputText [disabled]="true" [(ngModel)]="selectedContact.state">
                            <span>Issuing State</span>
                        </div>
                        OR
                        <div class="input-field" style="flex: 1">
                            <input type="text" pInputText [(ngModel)]="purchaseOrder.californiaIdNumber">
                            <span>California Identification Card Number</span>
                        </div>
                    </div>
                    <div class="row{{deviceManager.isMobile ? '-mobile' : ''}}">
                        <!-- <div class="input-field" style="flex: 1">
                            <input type="text" pInputText [(ngModel)]="purchaseOrder.vehicleNumber">
                            <span>Vehicle License Plate Number</span>
                        </div> -->
                        <div class="input-field" style="flex: 1">
                            <input type="text" pInputText [(ngModel)]="purchaseOrder.vehicleState">
                            <span>Issuing State</span>
                        </div>
                        <div class="input-field" style="flex: 1">
                            <input type="text" pInputText [(ngModel)]="purchaseOrder.vehicleNumber">
                            <span>Registration #</span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="color: red; font-size: .8rem; margin-top: -2px;" *ngIf="selectedContact?.valid == false">Contact data is incomplete</div>
        </div>

        <div class="place-of-sale" *ngIf="pageType == PageType.California && selectedPaymentTypes.includes(PaymentType.Cash)">
            <div class="title">Place of Sale or Purchase</div>
            <div class="fields">
                <div class="dropdown">
                    <p-dropdown [options]="placeOfSaleOptions" optionLabel="name" optionValue="value" placeholder="Select place" [(ngModel)]="purchaseOrder.placeOfSale" appendTo="body"></p-dropdown>
                </div>
                <div class="infos{{deviceManager.isMobile ? '-mobile' : ''}}" *ngIf="purchaseOrder.placeOfSale == 1 || purchaseOrder.placeOfSale == 2">
                    <div class="input-field address">
                        <div>{{purchaseOrder.placeOfSale == 1 ? poManager.current.vendor.address : poManager.current.location.address}}</div>
                        <span>Street Address</span>
                    </div>
                    <div class="input-field city">
                        <div>{{purchaseOrder.placeOfSale == 1 ? poManager.current.vendor.city : poManager.current.location.city}}</div>
                        <span>City</span>
                    </div>
                    <div class="input-field state">
                        <div>{{purchaseOrder.placeOfSale == 1 ? poManager.current.vendor.state : poManager.current.location.state}}</div>
                        <span>State</span>
                    </div>
                    <div class="input-field zip">
                        <div>{{purchaseOrder.placeOfSale == 1 ? poManager.current.vendor.zip : poManager.current.location.zip}}</div>
                        <span>Zip Code</span>
                    </div>
                </div>
                <div class="infos{{deviceManager.isMobile ? '-mobile' : ''}}" *ngIf="purchaseOrder.placeOfSale == 3">
                    <div class="input-field address">
                        <input type="text" pInputText [(ngModel)]="purchaseOrder.placeOfSaleLocationAddress">
                        <span>Street Address</span>
                    </div>
                    <div class="input-field city">
                        <input type="text" pInputText [(ngModel)]="purchaseOrder.placeOfSaleLocationCity">
                        <span>City</span>
                    </div>
                    <div class="input-field state">
                        <input type="text" pInputText [(ngModel)]="purchaseOrder.placeOfSaleLocationState">
                        <span>State</span>
                    </div>
                    <div class="input-field zip">
                        <input type="text" pInputText [(ngModel)]="purchaseOrder.placeOfSaleLocationZip">
                        <span>Zip Code</span>
                    </div>
                </div>
            </div>
            <div style="color: red; font-size: .8rem; margin-top: -2px;" *ngIf="selectedContact?.valid == false">Contact data is incomplete</div>
        </div>

        <div class="buttons">
            <p-button icon="pi pi-times" label="Cancel" severity="secondary" (click)="onCancel()"></p-button>
            <p-button icon="pi pi-save" label="Save" (click)="onSave()" [disabled]="selectedVendor == null || selectedContact == null"></p-button>
        </div>
    </div>
</div>